import R from 'ramda'
import { useQuery } from 'react-query'

import getCurrentUser from 'Packages/flashcards/services/getCurrentUser'

const TWO_HOURS_IN_MS = 1000 * 60 * 60 * 2

export default function useUserAccess() {
  const {
    data: user,
    isLoading: userIsLoading,
    refetch: refetchUser,
  } = useQuery('user', getCurrentUser, {
    refetchOnWindowFocus: false,
    staleTime: TWO_HOURS_IN_MS,
  })

  const userLoggedIn = !!user

  const userHasAccess = R.any(Boolean, [
    user?.id !== null && user?.access === 'Plus',
    user?.id !== null && user?.access === 'Lite',
  ])

  return {
    userIsLoading,
    userHasAccess,
    userLoggedIn,
    userId: user?.id,
    userData: user,
    refetchUser,
  }
}
